<template>
  <PSection tft-university-showdown-leaderboard theme="white">
    <PItem class="info-section">
      <div class="board">
        <h4 class="anchor"><span>리더보드</span></h4>
        <div v-if="isComingSoon" class="table-holder coming-soon">
          <table class="skeleton">
            <thead>
              <tr>
                <th>순위</th>
                <th>대학교명</th>
                <th>포인트</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="n in 12" :key="`skeleton-${n}`">
                <td /><td /><td />
              </tr>
            </tbody>
          </table>
          <div class="notice">
            <p class="hexes"><i /><i /><i /></p>
            <h5>COMING SOON</h5>
            <i class="line" />
            <p class="desc">대회가 시작되면 대학별 순위가 공개됩니다.</p>
          </div>
        </div>
        <template v-else>
          <div class="search-con">
            <SearchInput v-model="searchInp" placeholder="대학교명을 입력해주세요." @click="search" />
          </div>
          <div v-if="!isLogin" class="my-guest">
            <p>로그인하고 <em>내 대학교의 순위</em>를 확인해 보세요!</p>
            <button @click="login">로그인</button>
          </div>
          <div class="table-holder">
            <table v-if="rows.length">
              <thead>
                <tr>
                  <th>순위</th>
                  <th>대학교명</th>
                  <th>포인트</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in rows" :key="`${row.myData ? 'my' : 'rank'}-${row.rank}`" :class="{ my: row.myData }">
                  <td class="rank">
                    <span v-if="row.rank <= 3" :class="['hex', `rank-${row.rank}`]">{{ row.rank }}</span>
                    <span v-else>{{ row.rank }}위</span>
                  </td>
                  <td class="name">{{ row.universityName }}</td>
                  <td class="point">{{ row.point }}P</td>
                </tr>
              </tbody>
            </table>
            <p v-else class="no-data">검색 결과가 없습니다.</p>
          </div>
        </template>
      </div>
      <i class="rule" />
    </PItem>
    <figure class="pengu pengu-right" v-prx:intro="{ r: [7, 9], tx: [200, 0], ty: [250, 0], o: [0, 1] }">
      <img src="/img/pages/tftUniversityShowdown/pengu_01.png" alt="">
    </figure>
    <figure class="pengu pengu-left" v-prx:intro="{ r: [9, 11], tx: [-200, 0], ty: [250, 0], o: [0, 1] }">
      <img src="/img/pages/tftUniversityShowdown/pengu_02.png" alt="">
    </figure>
  </PSection>
</template>

<script>
import SearchInput from '@/views/components/common/input/SearchInput.vue';

// 임시: 대학 리그 코드 확정 시 $services.home.getUniversityRankings(universityName 검색·isMy 내 대학교)로 교체
const universityNames = ['한빛대학교', '새솔대학교', '푸른대학교', '나래대학교', '가람대학교', '누리대학교', '다온대학교', '라온대학교', '미르대학교', '별빛대학교', '솔빛대학교', '하늬대학교'];

export default {
  name: 'TftUniversityShowdownLeaderboard',
  components: { SearchInput },
  data() {
    return {
      searchInp: '',
      keyword: '',
      // 임시: 기본은 순위 0건(COMING SOON), dev 확인용으로 ?dummy=1 이면 더미 순위 표시
      ranks: !this.$route.query.dummy ? [] : universityNames.map((universityName, i) => ({ rank: i + 1, universityName, point: 120 - i * 8 })),
      // 임시: 로그인 사용자의 대학교 대신 고정 값
      myUniversityName: '다온대학교',
    };
  },
  computed: {
    isComingSoon() {
      return !this.ranks.length;
    },
    isLogin() {
      return this.$store.getters['auth/isLogin'];
    },
    myRank() {
      return this.ranks.find(item => item.universityName === this.myUniversityName);
    },
    rows() {
      const filtered = this.ranks.filter(item => item.universityName.includes(this.keyword));
      return this.isLogin && this.myRank ? [{ ...this.myRank, myData: true }, ...filtered] : filtered;
    },
  },
  watch: {
    searchInp() {
      if (!this.searchInp) this.search();
    },
  },
  methods: {
    // 임시: API 연결 전까지 화면 안에서 필터링
    search() {
      this.keyword = this.searchInp.trim();
    },
    login() {
      this.$services.auth.oAuthLogin(true).catch(() => {});
    },
  },
};
</script>

<style lang="less">
@import '~@/less/proj.less';
@keyframes dodongsilTft {
  0% { transform+_: translateY(-10px) scale(1); }
  40% { transform+_: translateY(10px) scale(.98); }
  100% { transform+_: translateY(-10px) scale(1); }
}

[tft-university-showdown-leaderboard] { .rel; .tc; .font-g; .mt(64); .p(0, 20, 60);
  .info-section { .ani-base;
    .intro-up(1, {.ani-on});
  }
  .board { .rel; .z(3); .max-w(780); .mh-c; .p(0, 16, 24); .bgc(fade(@showdown-navy-deep, 80%)); box-shadow: inset 0 0 0 1px fade(@showdown-gold, 45%);
    clip-path: polygon(0 0, 100% 0, 100% calc(100% - 22px), calc(100% - 13px) 100%, 13px 100%, 0 calc(100% - 22px));
  }
  .anchor { .rel; .h(40); .m(0, -16, 20);
    &:before { .cnt; .abs; .lb(0, 0); .wh(100%, 4); .bgc(@showdown-gold); }
    > span { .rel; .ib; .h(40); .p(0, 40); .fs(18, 40); .bold; .ls(-0.5); .c(@showdown-navy-deep); .bgc(@showdown-gold);
      clip-path: polygon(0 0, 100% 0, calc(100% - 23px) 100%, 23px 100%);
    }
  }
  .search-con { .mb(12);
    .search-input-box { width: calc(100% - 48px); .mr(8); }
    .search-input_input[type='text'] { .bgc(fade(@showdown-navy-deep, 25%)); .c(@showdown-cream); .fs(13); .tl;
      &::placeholder { .c(fade(@showdown-cream, 60%)); }
    }
    .search-input_button--search { .bgc(@showdown-gold); .-a(@showdown-gold, 2);
      .opacity5 { .o(1); }
    }
  }
  .my-guest { .flex; .items-center; .flex-jc(space-between); .mb(12); .p(12, 14); .bgc(fade(@showdown-navy-deep, 22%)); .tl;
    > p { .fs(13, 18); .c(@showdown-cream); .ls(-0.5);
      > em { .c(@showdown-gold); .bold; }
    }
    > button { .no-shrink; .ml(10); .h(32); .p(0, 20); .fs(13); .bold; .c(@showdown-navy-deep); .bgc(@showdown-gold);
      clip-path: polygon(10px 0, 100% 0, calc(100% - 10px) 100%, 0 100%);
    }
  }
  .table-holder { .min-h(713); }
  table { .w(100%); border-collapse: separate; border-spacing: 0 4px;
    th { .h(34); .fs(12, 12); .medium; .c(@showdown-navy-deep); .bgc(@showdown-gold);
      &:nth-of-type(1) { .w(18%); }
      &:nth-of-type(3) { .w(24%); }
    }
    td { .h(52); .fs(14, 14); .bold; .bgc(fade(@showdown-navy, 70%)); }
    tbody tr:nth-of-type(2n) td { .bgc(fade(@showdown-navy, 40%)); }
    .rank { .c(fade(@showdown-cream, 70%));
      .hex { .ib; .wh(34, 30); .fs(15, 30); .c(@showdown-navy-deep); clip-path: polygon(25% 0, 75% 0, 100% 50%, 75% 100%, 25% 100%, 0 50%);
        &.rank-1 { .bgc(@showdown-gold); }
        &.rank-2 { .bgc(@showdown-cream); }
        &.rank-3 { .bgc(@showdown-gold-light); }
      }
    }
    .name { .c(@showdown-cream); }
    .point { .c(@showdown-gold); }
    tr.my td { .bgc(fade(@showdown-cream, 16%)); .-b(@showdown-gold, 2px);
      &.name:before { content: 'MY'; .ib; .vam; .mr(8); .p(0, 8); .fs(11, 18); .bgc(@showdown-gold); .c(@showdown-navy-deep);
        clip-path: polygon(5px 0, 100% 0, calc(100% - 5px) 100%, 0 100%);
      }
    }
  }
  .no-data { .p(60, 0); .fs(14); .c(fade(@showdown-cream, 60%)); }
  .coming-soon { .rel;
    .skeleton { .o(.35); }
    .notice { .abs; .lt(0, 0); .wh(100%); .flex; .flex-column; .items-center; .flex-jc(center);
      background: radial-gradient(ellipse 60% 45% at 50% 50%, fade(@showdown-navy-deep, 85%), transparent 100%);
    }
    .hexes { .flex; .gap(8); .mb(18);
      > i { .wh(18, 16); clip-path: polygon(25% 0, 75% 0, 100% 50%, 75% 100%, 25% 100%, 0 50%);
        &:nth-of-type(1) { .bgc(@showdown-gold-light); }
        &:nth-of-type(2) { .bgc(@showdown-gold); }
        &:nth-of-type(3) { .bgc(@showdown-cream); }
      }
    }
    h5 { .font-russo; .fs(36, 40); .ls(1); .c(@showdown-cream); }
    .line { .block; .wh(140, 4); .m(16, auto); .bgc(@showdown-gold); }
    .desc { .fs(14, 20); .ls(-0.5); .c(fade(@showdown-cream, 80%)); }
  }
  .rule { .rel; .block; .wh(272, 6); .mh-c; .mt(58); .mb(10); .bgc(@showdown-gold);
    &:after { .cnt; .abs; .lt(50%, -5); .t-x(-50%); .wh(96, 16); .bgc(@showdown-gold);
      clip-path: polygon(0 0, 100% 0, calc(100% - 9px) 100%, 9px 100%);
    }
  }
  .pengu { .hide; .abs; .z(2); width: ~"min(320px, calc(50vw - 420px))"; .events-none;
    > img { .rel; .block; .w(100%); animation: dodongsilTft 2.5s 0.5s ease-in-out infinite; }
    &:after { .cnt; .abs; .lb(50%, -24); .t-x(-50%); .wh(70%, 36); .br(50%); .bgc(fade(@showdown-navy-deep, 35%)); filter: blur(12px); }
    &.pengu-right { .t(40); left: calc(50% + 410px); }
    &.pengu-left { .t(560); right: calc(50% + 410px);
      > img { animation-delay: 1.2s; }
    }
  }

  @media (@tl-up) {
    .mt(96); .pb(100);
    .board { .p(0, 44, 44); }
    .anchor { .h(48); .m(0, -44, 32);
      > span { .h(48); .p(0, 56); .fs(22, 48);
        clip-path: polygon(0 0, 100% 0, calc(100% - 28px) 100%, 28px 100%);
      }
    }
    .search-con { .w(320); .ml(auto); .mb(16);
      .search-input_input[type='text'] { .fs(14); }
    }
    .my-guest { .p(16, 20); .mb(16);
      > p { .fs(16, 22); }
      > button { .h(40); .p(0, 28); .fs(15); }
    }
    .table-holder { .min-h(723); }
    table {
      th { .h(44); .fs(14, 14); }
      td { .h(52); .fs(18, 18); }
      .rank .hex { .wh(40, 36); .fs(17, 36); }
    }
    .rule { .w(472); .mt(80); .mb(32); }
    .coming-soon {
      .hexes { .mb(24);
        > i { .wh(24, 21); }
      }
      h5 { .fs(56, 60); }
      .line { .w(200); .m(20, auto); }
      .desc { .fs(17, 24); }
    }
  }

  @media (@ds-up) {
    .pengu { .block; }
  }
}
</style>
